module.exports = __webpack_public_path__ + "static/media/7.8bfb4fb8.jpg";